export default {
  name: '考试',
  permissionsKey:"JG-KS",
  icon: 'fa fa-graduation-cap',
  children: {
    examList:{
      name: '考试列表',
      permissionsKey:"JG-KS-KSLB",
      path: '/exam_manage/exam_list',
    },
    // testPaperAnalysis:{
    //   name: '试卷分析',
    //   permissionsKey:"",
    //   path: '/exam_manage/test_paper_analysis',
    // },
    // testPaperManage:{
    //   name: '试卷管理',
    //   permissionsKey:"",
    //   path: '/exam_manage/test_paper_manage',
    // }
  }
};
